import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { evaluationCommentsManager, type IEvaluationComment } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { getters } from './getters';

const EVALUATION_COMMENT_MODULE = 'evaluationComment';

const searchModule = getSearchModule(evaluationCommentsManager);
const dataObjectModule = getDataObjectsModule<IEvaluationComment>(evaluationCommentsManager, 5);

const evaluationCommentModuleInstance = merge<unknown>(dataObjectModule, searchModule, { getters });
store.registerModule(EVALUATION_COMMENT_MODULE, evaluationCommentModuleInstance);

export { EVALUATION_COMMENT_MODULE };
